import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-zinc-950 text-zinc-300" data-id="element-73" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-orange-500 shadow-[0_0_10px_rgba(249,115,22,0.6)]" aria-hidden="true" data-id="element-74" data-mp="3ggtxuh7dth4p" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-75" data-mp="32pp601a99t4x">
        <p className="text-xs" data-id="element-76" data-mp="36qhhl16loa4d">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}